// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2chvT","alertIcon":"ConfirmModal_alertIcon__1bPxk"};